/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type React from "react"
import type { JSX } from "react"

import { hasDeveloperAccess } from "../../features/access-rights/access-rights"

import { useAppState } from "./app-hooks"

interface Props {
    children: React.ReactNode
}

/**
 * A component that only renders its children if the current user has developer privileges.
 *
 * This component checks if the current user has a Developer role.
 */
export const DeveloperAccess = ({ children }: Props): JSX.Element => {
    const appState = useAppState()

    return hasDeveloperAccess(appState.roles) ? <>{children}</> : <></>
}
